// extracted by mini-css-extract-plugin
module.exports = {"sectionItem":"SectionList_sectionItem__1_BGI","sectionTitle":"SectionList_sectionTitle__2x7J6","sectionContent":"SectionList_sectionContent__19neL"};